<app-base-dialog
  [visible]="visible()"
  (visibleChange)="close()"
  [title]="title() ?? ''"
  testId="project-step-description-dialog"
  cancelLabel="common.close"
>
  <app-safe-html-output
    [html]="currentTranslation()?.mainDescription"
    testDataId="project-step-description-main-description"
  />

  <div class="mb-4" [attr.data-testid]="'project-step-description-accordion-guidance-wrapper'">
    <h2>{{ 'projectStep.description.accordion1' | transloco }}</h2>
    <p-accordion
      [multiple]="false"
      [attr.data-testid]="'project-step-description-accordion-guidance'"
    >
      <p-accordion-panel [value]="'guidance'">
        <p-accordion-header [attr.data-testid]="'project-step-description-header-guidance'">
          {{ 'projectStep.description.accordion1.panel1' | transloco }}
        </p-accordion-header>
        <p-accordion-content [attr.data-testid]="'project-step-description-content-guidance'">
          <app-safe-html-output [html]="currentTranslation()?.contentNavigation" />
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel [value]="'requiredInformation'">
        <p-accordion-header
          [attr.data-testid]="'project-step-description-header-required-information'"
        >
          {{ 'projectStep.description.accordion1.panel2' | transloco }}
        </p-accordion-header>
        <p-accordion-content
          [attr.data-testid]="'project-step-description-content-required-information'"
        >
          <app-safe-html-output [html]="currentTranslation()?.requiredInformation" />
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel [value]="'examples'">
        <p-accordion-header [attr.data-testid]="'project-step-description-header-examples'">
          {{ 'projectStep.description.accordion1.panel3' | transloco }}
        </p-accordion-header>
        <p-accordion-content [attr.data-testid]="'project-step-description-content-examples'">
          <app-safe-html-output [html]="currentTranslation()?.examples" />
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>

  <div [attr.data-testid]="'project-step-description-accordion-support-wrapper'">
    <h2>{{ 'projectStep.description.accordion2' | transloco }}</h2>
    <p-accordion
      [multiple]="false"
      [attr.data-testid]="'project-step-description-accordion-support'"
    >
      <p-accordion-panel [value]="'support'">
        <p-accordion-header [attr.data-testid]="'project-step-description-header-support'">
          {{ 'projectStep.description.accordion2.panel1' | transloco }}
        </p-accordion-header>
        <p-accordion-content [attr.data-testid]="'project-step-description-content-support'">
          <app-safe-html-output [html]="currentTranslation()?.support" />
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel [value]="'individualNotes'">
        <p-accordion-header [attr.data-testid]="'project-step-description-header-individual-notes'">
          {{ 'projectStep.description.accordion2.panel2' | transloco }}
        </p-accordion-header>
        <p-accordion-content
          [attr.data-testid]="'project-step-description-content-individual-notes'"
        >
          <app-safe-html-output [html]="currentTranslation()?.individualNotes" />
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</app-base-dialog>
